import { render, staticRenderFns } from "./adInfoSelectClass.vue?vue&type=template&id=36c75bb4&scoped=true"
import script from "./adInfoSelectClass.vue?vue&type=script&lang=js"
export * from "./adInfoSelectClass.vue?vue&type=script&lang=js"
import style0 from "./adInfoSelectClass.vue?vue&type=style&index=0&id=36c75bb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c75bb4",
  null
  
)

export default component.exports